var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-menu-faturamento',{attrs:{"ativo":"autorizar-cancelamentos"}}),_c('p',[_vm._v("Autorizar Cancelamento")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }